<template>
  <div class="form-group align-items-center">
    <input type="hidden" :name="name" :id="name + 'notselected'" value="" />
    <label 
      v-if="label" 
      :class="[labelClass(), labelClasses]" 
      class="margin-bottom-10"
    >
      <span v-if="field.required" class="required">*</span>
      {{label}}
    </label>
    <div class="btn-group btn-group-toggle row gx-2 gy-2" data-toggle="buttons" :class="selectionClass()">
      <div v-for="(option,idx) in options" :key="idx" :class="innerClass(this.options.length)">
        <label class="" >
          <input class="red-radio" type="radio" :name="name" :required="field.required" autocomplete="off" :value="option.val" :checked="option.val==value" v-model="selected"> <span v-html="option.text"></span>
          <!-- class="nooption" -->
        </label>
      </div>
    </div>
    <!-- Move nested fields outside the option loop so they can span full width -->
    <div v-if="selectedOptionWithFields" v-show="this.selected==selectedOptionWithFields.val" :class="nestedFieldsWrapperClass()">
      <div v-for="(field,idx) in selectedOptionWithFields.fields" :key="idx" :class="nestedFieldColumnClass()">
        <FormFieldComponent 
          :field="customizeNestedField(field)" 
        />
      </div>
    </div>
    <div class="invalid-feedback" :id="`${name}invalid`">{{field.error_message}}</div>
  </div>
</template>
<script>
export default {
  props: {
    label: String,
    type: String,
    name: String,
    value: Number,
    options: Array,
    subfields: Object,
    field: Object,
  },
  data() {
    return {
      selected: null
    }
  },
  computed: {
    labelClasses() {
      const classes = [];
      
      // Add bold class if boldLabel is true
      if (this.field.bold_label) {
        classes.push('bold');
      }
      
      return classes;
    },
    selectedOptionWithFields() {
      // Find the currently selected option that has nested fields
      if (this.selected !== null && this.options) {
        return this.options.find(option => option.val == this.selected && option.fields);
      }
      return null;
    }
  },
  methods: {
    labelClass() {
      if (this.field.horizontal) {
        return "col-6";
      }
      return "col-12";
    },
    selectionClass() {
      if (this.field.horizontal) {
        return "col-6 padding-right-20";
      }
      return "col-12";
    },
    innerClass(optionsNum) {
      // If horizontal_options: true, make options appear horizontally (one next to the other)
      if (this.field.horizontal_options === true) {
        // Calculate column size based on number of options
        const colSize = Math.floor(12 / optionsNum);
        return `col-${colSize}`;
      }
      
      // Default vertical stacking behavior
      if (optionsNum <= 4 ) {
        return "col-12";
      }
      var col_size = 12 / optionsNum
      if (this.field.horizontal) {
        return "col-6";
      }
      if (this.field.wide) {
        return "col-" + col_size;
      }
      return "col-12";
    },
    nestedFieldColumnClass() {
      if (this.field.horizontal_options === true) {
        return "col-12 col-xl-6";
      }
      return "col-12";
    },
    nestedFieldsWrapperClass() {
      if (this.field.horizontal_options === true) {
        // Use col-12 to span full width and row for horizontal layout of nested fields
        return "col-12 row";
      }
      return "col-12";
    },
    customizeNestedField(field) {
      // Remove desktopClass since we're handling it with wrapper divs
      return field;
    }
  }
}
</script>
<style scoped>
.padding-right-20 {
  padding-right: 27px;
}
.required {
  color: red;
  margin-left: 5px;
}
</style>